import * as types from '../mutation-types';
import { ad } from '../../api';

const state = {
  // 首頁廣告位
  index: [],
  charge: [],
};

const getters = {
  // eslint-disable-next-line
  getAdsByPosition: (s) => (position) => {
    switch (position) {
      case 1:
        return s.index;
      case 2:
        return s.charge;
      default:
        return [];
    }
  },
};

const actions = {
  fetchAd({ commit }, position) {
    return ad.get(position).then(({ data: response }) => {
      commit(types.RECEIVE_AD, { position, data: response.data });
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_AD](s, { position, data }) {
    switch (position) {
      case 1:
        s.index = data;
        break;
      case 2:
        s.charge = data;
        break;
      default:
        break;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/ad.js